import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = { class: "gfu-heading__wrapper" }
const _hoisted_3 = { class: "gfu-heading__actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "gfu-box gfu-box--thick _mt-6 _mb-6"
}
const _hoisted_6 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_7 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_8 = { class: "gfu-stats-table__value" }
const _hoisted_9 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_10 = { class: "gfu-stats-table__value" }
const _hoisted_11 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_12 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_13 = { class: "gfu-stats-table__value" }
const _hoisted_14 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_15 = { class: "gfu-stats-table__value" }
const _hoisted_16 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_17 = { class: "gfu-stats-table__value" }
const _hoisted_18 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_19 = { class: "gfu-stats-table__value" }
const _hoisted_20 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_21 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_22 = { class: "gfu-stats-table__value" }
const _hoisted_23 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_24 = { class: "gfu-stats-table__value" }
const _hoisted_25 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_26 = { class: "gfu-stats-table__value" }
const _hoisted_27 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_28 = { class: "gfu-stats-table__value" }
const _hoisted_29 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_30 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m" }
const _hoisted_31 = { class: "gfu-heading gfu-heading--text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_toggle_field = _resolveComponent("toggle-field")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_apexchart = _resolveComponent("apexchart")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "gfu-heading gfu-heading--main _mt-6" }, " System health ", -1 /* CACHED */)),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_toggle_field, {
          modelValue: $data.autoRefresh,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.autoRefresh) = $event)),
          class: "_mt-1",
          "display-name": "Auto-refresh",
          type: "switch",
          inline: true,
          enabled: !_ctx.isProcessing
        }, null, 8 /* PROPS */, ["modelValue", "enabled"]),
        _createElementVNode("button", {
          class: "_ml-3 gfu-btn gfu-btn--nano gfu-btn--compact gfu-btn--accent",
          disabled: _ctx.isProcessing,
          onClick: _cache[1] || (_cache[1] = (...args) => ($options.loadSystemHealthInfo && $options.loadSystemHealthInfo(...args)))
        }, "Refresh", 8 /* PROPS */, _hoisted_4)
      ])
    ]),
    ($data.model)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "gfu-heading gfu-heading--main gfu-heading--inline" }, "Misc", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Total memory allocated (reported by GC)", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$format($data.model.totalConsumedMemoryBytes / 1000000, 'N2')) + "Mb", 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Operating system threads", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_10, _toDisplayString($data.model.operatingSystemThreads), 1 /* TEXT */)
            ])
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "gfu-heading gfu-heading--main gfu-heading--inline _mt-6" }, "Worker threads", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Active worker threads", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_13, _toDisplayString($data.model.activeThreadPoolWorkerThreads), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Min worker threads", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_15, _toDisplayString($data.model.minThreadPoolWorkerThreads), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Max workrer threads", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_17, _toDisplayString($data.model.maxThreadPoolWorkerThreads), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Max reported worker threads", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_19, _toDisplayString($data.model.maximumReportedWorkerThreads), 1 /* TEXT */)
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("h1", { class: "gfu-heading gfu-heading--main gfu-heading--inline _mt-6" }, "Completion port threads", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Active completion port threads", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_22, _toDisplayString($data.model.activeThreadPoolCompletionPortThreads), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Min completion port threads", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_24, _toDisplayString($data.model.minThreadPoolCompletionPortThreads), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Max completion port threads", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_26, _toDisplayString($data.model.maxThreadPoolCompletionPortThreads), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--text" }, "Max reported completion port threads", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_28, _toDisplayString($data.model.maximumReportedCompletionPortThreads), 1 /* TEXT */)
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "gfu-heading gfu-heading--main gfu-heading--inline _mt-6" }, "Services", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("h2", _hoisted_31, "Cache provider: " + _toDisplayString($data.model.cacheProviderName), 1 /* TEXT */)
            ])
          ]),
          _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
        ]))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createVNode(_component_apexchart, {
      height: "250",
      type: "line",
      options: $options.activeWorkersChartOptions,
      series: $options.activeWorkersChartSeries
    }, null, 8 /* PROPS */, ["options", "series"]), [
      [_vShow, $data.model.activeWorkerThreadsReadings.length > 0]
    ])
  ]))
}